export const ExecutionsSymbolValidatorKey = 'executionsSymbol';
export const MinimumNumberValidatorKey = 'min';
export const MaximumNumberValidatorKey = 'max';
export const MaximumAmountValidatorKey = 'maxAmount';
export const PatternValidatorKey = 'pattern';
